module.exports = __webpack_public_path__ + "img/zl_hover.78d8dbb8.png";